// extracted by mini-css-extract-plugin
module.exports = {"empty":"index-empty-qCbhL","emptyInner":"index-emptyInner-KdQNk","frame":"index-frame-2r7Aw","iconTip":"index-iconTip-11IBP","emptyShadow":"index-emptyShadow-srFhe"};